const state = {
  name: '',
  email: '',
  isFilled: false
};

const getters = {
  contact: state => state
};

const actions = {
  setContact({commit}, contact) {
    // Assigns contact info for sentry
    window.Raven.setUserContext({
      email: contact.email,
      name: contact.name
    });
    return commit('SET_CONTACT', contact);
  },

  // For setting an item in the contact object
  setContactItem({commit}, {prop, value}) {
    switch (prop) {
      case 'contactName':
        return commit('SET_CONTACT_NAME', value);
      case 'contactEmail':
        return commit('SET_CONTACT_EMAIL', value);
      default:
        return;
    }
  },

  clearContact({commit}) {
    return commit('SET_CONTACT', {name: '', email: '', isFilled: false});
  }
};

const mutations = {
  SET_CONTACT(state, contact) {
    state.name = contact.name;
    state.email = contact.email;
    state.isFilled = contact.isFilled;
  },
  SET_CONTACT_NAME(state, name) {
    state.name = name;
  },
  SET_CONTACT_EMAIL(state, email) {
    state.email = email;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/vuex/modules/contact.js